import "core-js/modules/es.array.iterator.js";
import React from 'react';
export const offsetHeightHeader = 44;
export const offsetHeightMargins = 8 + 8;
export const defaultOffsetHeight = offsetHeightHeader + offsetHeightMargins;
export const defaultOffsetWidth = 8;
const getLayoutDimensions = (offsetHeight = defaultOffsetHeight, offsetWidth = defaultOffsetWidth) => {
  const height = window.innerHeight - offsetHeight;
  const width = window.innerWidth - offsetWidth;
  return {
    width,
    height
  };
};
export const useArchiveLayoutDimensions = (offsetHeight = defaultOffsetHeight, offsetWidth = defaultOffsetWidth) => {
  const [layoutDim, setLayoutDim] = React.useState(getLayoutDimensions(offsetHeight, offsetWidth));
  React.useEffect(() => {
    const onResize = () => {
      setLayoutDim(getLayoutDimensions(offsetHeight, offsetWidth));
      // TODO accept ref container to apply instead of window when static view ?
      // TODO add some debounce ?? make some tests -> maybe not needed bc React optimize virtual DOM...
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return {
    layoutDim
  };
};
export const getFullscreenDimensions = () => {
  return {
    width: window.screen.width,
    height: window.screen.height
  };
};